import { render } from "./Registartion.vue?vue&type=template&id=03582172&scoped=true"
import script from "./Registartion.vue?vue&type=script&lang=js"
export * from "./Registartion.vue?vue&type=script&lang=js"

import "./Registartion.vue?vue&type=style&index=0&id=03582172&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03582172"]])

export default __exports__